module.exports = __webpack_public_path__ + "static/media/image.09dd10d2.png";